// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__6NqRk","load":"Spinner_load__KpOGa","spinnerMain":"Spinner_spinnerMain__aO7i0"};